import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css';
import VueGoogleMaps from '@fawmi/vue-google-maps'

createApp(App)
    .use(store)
    .use(router)
    .use(VueGoogleMaps, {load: {key: process.env.VUE_APP_GOOGLE_KEY}})
    .mount('#app')